import React from "react";
import { FormattedDate, FormattedTime } from "react-intl";
import { Paragraph } from "@trainline/depot-web";
import { setZeroTimezoneOffset } from "@trainline-shareable/utils";
import IconArrow from "../../assets/icons/IconArrow";
import useJourneyPlan from "../../hooks/useJourneyPlan";
import getJourneyArrivalDate from "../../utils/date-and-time/getJourneyArrivalDate";
import getJourneyDepartureDate from "../../utils/date-and-time/getJourneyDepartureDate";
import * as s from "./JourneyTimeInformation.module.css";
const JourneyTimeInformation = () => {
  const journey = useJourneyPlan();
  const departureAt = getJourneyDepartureDate(journey);
  const arrivalAt = getJourneyArrivalDate(journey);
  if (!departureAt || !arrivalAt) {
    return null;
  }
  const departureAtTimezoneAdjusted = new Date(setZeroTimezoneOffset(departureAt));
  const arrivalAtTimezoneAdjusted = new Date(setZeroTimezoneOffset(arrivalAt));
  return /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    fontWeight: "bold",
    typeStyle: "small",
    className: s.journeyTimeInformation
  }, /* @__PURE__ */ React.createElement(FormattedDate, {
    value: departureAtTimezoneAdjusted,
    weekday: "short",
    day: "numeric",
    month: "short",
    hour12: false,
    timeZone: "UTC"
  }, (date) => /* @__PURE__ */ React.createElement("span", null, `${date.replace(/,/g, "")},`)), /* @__PURE__ */ React.createElement(FormattedTime, {
    value: departureAtTimezoneAdjusted,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC"
  }), /* @__PURE__ */ React.createElement(IconArrow, null), /* @__PURE__ */ React.createElement(FormattedTime, {
    value: arrivalAtTimezoneAdjusted,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC"
  }));
};
var JourneyTimeInformation_default = JourneyTimeInformation;
export {
  JourneyTimeInformation_default as default
};
